import type { Order } from "@/types/supabase";

interface OrderPriorityProps {
  priority: Order["priority"];
}

export function OrderPriority({ priority }: OrderPriorityProps) {
  const getPriorityDisplay = () => {
    // Convert priority to number for consistent comparison
    const priorityNumber = Number(priority);

    switch (priorityNumber) {
      case 20:
        return { emoji: "🔴", text: "Alta" };
      case 10:
        return { emoji: "🟡", text: "Media" };
      case 0:
      default:
        return { emoji: "🔵", text: "Estándar" };
    }
  };

  const { emoji, text } = getPriorityDisplay();

  return (
    <span className="inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full bg-gray-50 text-gray-500">
      <span className="text-gray-500 mr-1 text-[10px]">{emoji}</span>
      <span className="text-gray-500 text-xs">{text}</span>
    </span>
  );
}
